module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei5.svg";